<!-- 搜索部门树弹窗： 1.学分统计：选择工作单位；2.培训选调：选择选调范围 -->
<template>
  <el-dialog
    title="报表导出"
    class="rc-dialog"
    :visible.sync="exportDialog.flag"
    :close-on-click-modal="false"
    :destroy-on-close="false"
    width="40%"
  >
    <el-form ref="exportForm" :inline="true" :model="form" :rules="rules" size="small">
      <el-form-item label="学习时间：" prop="studyTime">
        <el-date-picker
            class="date-picker"
            value-format="yyyy-MM-dd"
            size="small"
            v-model="form.studyTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <butn
        class="czButn"
        @click="exportDialog.flag = false"
        size="small"
        title="取 消"
      />
      <butn
        btntype="primary"
        @click="confirm"
        size="small"
        title="确 定"
      />
    </span>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";

export default {
  components: { butn },
  props: {
    exportDialog: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  data() {
    return {
      form: {
        studyTime: [],
      },
      pickerOptions: {
        disabledDate: (time) => {
          let curDate = (new Date()).getTime()
          return time.getTime() > curDate;
        },
      },
      rules: {
        studyTime: [
          {
            required: true,
            message: "请选择学习时间",
            trigger: ["change", "blur"]
          }
        ],
      },
    };
  },
  methods: {

    confirm() {
      this.$refs.exportForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { start: this.form.studyTime[0], end: this.form.studyTime[1] });
        }
      });
    }
  }
}

</script>

<style lang="scss" scoped>
.checkbox_style {
  margin: 6px 0;
  margin-left: 24px;
}
</style>